import apiClient from './api';

class ObjectivesService {
  async create(objective) {
    const response = await apiClient.post('/budget/objectives', objective);
    return response.data;
  }

  async list() {
    const response = await apiClient.get('/budget/objectives');
    return response.data;
  }

  async getById(id) {
    const response = await apiClient.get(`/budget/objectives/${id}`);
    return response.data;
  }

  async update(id, objective) {
    const response = await apiClient.put(`/budget/objectives/${id}`, objective);
    return response.data;
  }

  async remove(id) {
    const response = await apiClient.delete(`/budget/objectives/${id}`);
    return response.data;
  }

  async getRealLeads({ clientId, accountId, dateFrom, dateTo }) {
    const params = new URLSearchParams({ clientId, accountId, dateFrom, dateTo });
    const response = await apiClient.get(`/budget/objectives-real-leads?${params.toString()}`);
    return response.data;
  }

  async getTreeRealTracking({ objectiveId, tree }) {
    const response = await apiClient.post('/budget/objectives-tree-real-tracking', { objectiveId, tree });
    return response.data;
  }

  async getAllObjectivesTracking() {
    const response = await apiClient.get('/budget/all-objectives-tracking');
    return response.data;
  }

  async getDashboardSummary({ clientId, dateFrom, dateTo } = {}) {
    const params = new URLSearchParams();
    if (clientId) params.append('clientId', clientId);
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    const response = await apiClient.get(`/budget/dashboard/objectives-summary?${params.toString()}`);
    return response.data;
  }
}

export default new ObjectivesService();


